import type { Directive, DirectiveBinding } from 'vue'

type HTMLElementExpandType = HTMLElement & {
  __handleClick__: (...args: any[]) => any
}

/**
 * v-debounce
 * @description 防抖指令。如果存在arg，同时arg为字符串数字，则代表延迟时间，不传默认500ms；如果存在modifiers.immediate，则代表立即执行，不传默认延迟执行
 * @example
 * <button v-debounce="handleClick">按钮</button>
 * <button v-debounce:1000="handleClick">按钮</button>
 * <button v-debounce.immediate="handleClick">按钮</button>
 * <button v-debounce:1000.immediate="handleClick">按钮</button>
 */
const debounce: Directive = {
  beforeMount(el: HTMLElementExpandType, binding: DirectiveBinding) {
    const {
      arg,
      modifiers: { immediate },
      value
    } = binding
    if (typeof value !== 'function') {
      throw new Error('v-debounce must receive a function as value')
    }
    if (typeof arg === 'string' && isNaN(Number(arg))) {
      throw new Error('v-debounce arg must be a number')
    }
    let timer: number | null = null
    const delay = arg ? Number(arg) : 500

    el.__handleClick__ = (...args: any[]) => {
      args[0].stopPropagation()
      if (timer) window.clearTimeout(timer)
      if (immediate) {
        const callNow = !timer
        callNow && binding.value(...args)
        timer = window.setTimeout(() => {
          timer = null
        }, delay)
      } else {
        timer = window.setTimeout(() => {
          binding.value(...args)
        }, delay)
      }
    }

    el.addEventListener('click', el.__handleClick__)
  },
  beforeUnmount(el: HTMLElementExpandType) {
    document.removeEventListener('click', el.__handleClick__)
  }
}

export default debounce
